<template>
  <div class="dt-usermange-container">

    <div class="dt-search-bar">
      <div>
        <el-select v-model="filter.appType" placeholder="适用终端" size="large" style="width: 240px" @change="appTypeChange">
          <el-option label="小程序" value="1" />
          <el-option label="web" value="2" />
        </el-select>
        <el-select v-model="filter.type" placeholder="全部角色" size="large" style="width: 240px;margin-left:20px;" @change=""
          v-if="filter.appType === '1'">
          <el-option key="1" label="教师" value="1" />
          <el-option key="2" label="家长" value="2" />
        </el-select>
        <el-select v-model="filter.typeCode" placeholder="全部类别" size="large" style="width: 240px;margin-left:20px"
          @change="handleSearch">
          <template v-if="filter.appType === '1'">
            <el-option v-for="item in filter.type == 1 ? teacherTypeList : parentTypeList" :value="item.dict_code"
              :key="item.dict_code" :label="item.dict_name" />
          </template>
          <template v-if="filter.appType === '2'">
            <el-option v-for="item in webTypeList" :value="item.dict_code" :key="item.dict_code" :label="item.dict_name" />
          </template>
        </el-select>
        <el-input v-model="filter.keyWord" style="width: 360px;margin-left:20px" clear size="large" placeholder="搜索标题"
          @keyup.enter="handleSearch">
          <template #suffix>
            <img @click="handleSearch" class="dt-search-icon" src="@/assets/icon_search.png" alt="">
          </template>
        </el-input>
      </div>
      <el-button type="primary" size="large" @click="showDialog(-1)">新建文档</el-button>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="title" label="标题" width="300" align="center" />
      <el-table-column prop="role" label="适用角色" align="center" v-if="filter.appType === '1'" />
      <el-table-column prop="queType" label="类别" align="center" />
      <el-table-column label="操作" align="center" width="180">
        <template #default="{ row, $index }">
          <div class="dt-opera-cell">
            <div @click="showDialog($index)">修改</div>
            <div @click="batchDelete($index)">删除</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="15" hide-on-single-page
      @current-change="handleCurrentChange" />
    <el-dialog v-model="formVisible" title="新建/修改 文档" width="1200" top="3vh" destroy-on-close z-index="10">
      <el-form ref="ruleFormRef" :model="formItem" :rules="rules" label-width="auto" class="demo-ruleForm"
        :size="formSize" status-icon>
        <el-form-item label="标题" prop="title">
          <el-input v-model="formItem.title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="适用终端" prop="type" v-if="formItem.id === ''">
          <el-radio-group v-model="formItem.appType" @change="formAppTypeChange" >
            <el-radio :label="1">小程序</el-radio>
            <el-radio :label="2">web</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="适用角色" prop="type" v-if="formItem.appType === 1">
          <el-radio-group v-model="formItem.type" @change="">
            <el-radio :label="1">教师</el-radio>
            <el-radio :label="2">家长</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="所属类别" prop="typeCode">
          <el-select v-model="formItem.typeCode" placeholder="请选择类别">
            <template v-if="formItem.appType === 1">
              <el-option v-for="item in formItem.type == 1 ? teacherTypeList : parentTypeList" :value="item.dict_code"
                :key="item.dict_code" :label="item.dict_name">{{
                  item.dict_name }}</el-option>
            </template>
            <template v-if="formItem.appType === 2">
              <el-option v-for="item in webTypeList" :value="item.dict_code" :key="item.dict_code"
                :label="item.dict_name">{{
                  item.dict_name }}</el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="打开方式" prop="openType">
          <el-radio-group v-model="formItem.openType" @change="formItem.content = ''">
            <el-radio :label="1">文本</el-radio>
            <el-radio :label="2">链接</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <div v-if="formItem.openType == 1">
            <myTiny v-model="formItem.content" :value="formItem.content" :height="300"></myTiny>
          </div>
          <el-input v-else v-model="formItem.content" placeholder="请输入链接地址">
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="addAndEditSubmit();">
            确认
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import { del, getList, save, findUserInfo, changePassword } from "@/service/api";
import { getBaseDictList, getDictNameByCode } from "@/utils/util.js";
import myTiny from "./modules/myTiny.vue";
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'ZpFAQList',
  components: {
    myTiny
  },

  data() {
    return {
      formItem: {
        id: "",
        //所属用户类型(1:教师2:家长)
        type: 1,
        //标题
        title: "",
        //内容
        content: "",
        //打开方式
        openType: "1",
        //类别编码
        typeCode: "",
        //适用终端
        appType: 1
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        typeCode: [
          {
            required: true,
            message: "请选择类别",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
        ],
      },
      tableData: [],
      filter: {
        keyWord: "",
        // 类型编码
        typeCode: "",
        // 类型
        type: "1",
        //文档适用终端
        appType: "1"
      },
      sels: [],
      formVisible: false,
      //文档类型集合
      allTypeList: [],
      teacherTypeList: [],
      parentTypeList: [],
      //web端文档类别
      webTypeList: [],
      page: 1,
      total: 0,
    };
  },

  methods: {
    /**
     * @name 适用终端改变
     */
     async appTypeChange() {
      this.filter.typeCode = "";
      this.handleSearch();
    },
    /**
     * @name 新增、修改表单适用终端改变
     */
     async formAppTypeChange() {
      this.formItem.typeCode = "";
    },
    
    /**
     * @name 角色改变
     */
    async roleChange() {
      await this.getTypeListByUserType();
      this.handleSearch();
    },
    /**
     * @name 根据用户类型获取具体文档类别
     */
    async getTypeListByUserType() {
      let typecode = this.filter.type === "1" ? "701" : "702";
      this.typeList = await getBaseDictList(typecode, 1, 100);
    },
    /**
     * 查询
     */
    async handleSearch() {
      this.page = 1;
      this.tableData = await this.getDataList();
    },
    /**
     * 子组件更新表格数据
     */
    updateTableData(tableData) {
      this.tableData = tableData;
    },
    updateSels(selection) {
      this.sels = selection;
    },

    async handleCurrentChange(val) {

      this.page = val;
      this.tableData = await this.getDataList();
    },
    /**
     * @name 打开新增、编辑弹框
     * @param {*} index
     */
    showDialog(index) {
      let _this = this;
      //index不为-1时为修改
      if (index != -1) {
        //初始化修改表单
        _this.formItem = JSON.parse(JSON.stringify(_this.tableData[index]));
        _this.formVisible = true;
      } else {
        _this.formItem = {
          id: "",
          //所属用户类型(1:教师2:家长)
          type: 1,
          //标题
          title: "",
          //内容
          content: "",
          //打开方式
          openType: 1,
          //类别编码
          typeCode: "",
          appType:1
        }
        _this.formVisible = true;
      }
    },
    /**
     * @name 关闭新建文档窗口
     */
    cancel() {
      this.formVisible = false;
    },
    /**
     * @name 删除
     */
    batchDelete: function (index) {
      let ids = "";
      //多选删除
      if (index == -1) {
        ids = this.sels.map((item) => item.id).toString();
      } else {
        //单个删除
        ids = this.tableData[index].id;
      }
      let _this = this;
      let params = {
        id: ids,
      };

      ElMessageBox.confirm(
        '确认删除吗?',
        '提示',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          del(params)
            .then(async function (result) {
              if (result && parseInt(result.code) === 1) {
                _this.sels = []; //将已选项置为空
                ElMessage({
                  type: 'success',
                  message: '删除成功',
                })
                _this.tableData = await _this.getDataList();
              }
            })
            .catch(function (error) {
              ElMessage({
                type: 'info',
                message: '删除失败',
              })
            });

        })
        .catch(() => {

        })
    },

    async addAndEditSubmit() {
      try {
        if (!this.$refs.ruleFormRef) return
        await this.$refs.ruleFormRef.validate((valid, fields) => {
          if (valid) {
            let params = {
              id: this.formItem.id,
              type: this.formItem.type,
              title: this.formItem.title,
              content: this.formItem.content || '',
              openType: this.formItem.openType,
              typeCode: this.formItem.typeCode,
              appType: this.formItem.appType
            };

            save(params).then(async (res) => {
              if (res && parseInt(res.code) === 1) {
                ElMessage({
                  type: 'success',
                  message: '操作成功',
                })
                this.formVisible = false;
                this.tableData = await this.getDataList();
              }
            }).catch(err => {
              console.error('保存失败:', err);
              ElMessage.error('保存失败');
            });
          }
        })
      } catch (error) {
        console.error('表单验证错误:', error);
        ElMessage.error('表单验证失败');
      }
    },
    /**
     * 修改等操作后，保留在当前页
     */
    refshTable() {
      this.getDataList()
    },

    async getDataList() {
      let result = await getList({
        keyWord: this.filter.keyWord,
        appType: this.filter.appType,
        typeCode: this.filter.typeCode,
        type: this.filter.type,
        limit: 15,
        page: this.page
      })
      if (result && parseInt(result.code) === 1) {
        let list = result.data.rows.map((item) => {
          return {
            ...item,
            role: item.type == "1" ? "教师" : "家长",
            queType: getDictNameByCode(item.typeCode, this.allTypeList)
          }
        })
        this.total = result.data.total_rows;
        return list;
      }
    },

    /**
     * 根据用户ID获取用户信息。
     *
     * @param {Number} userId - 用户ID
     * @return {void}
     */
    async getToken() {
      const res = await findUserInfo({ userId: this.$route.query.userid });
      if (res?.code === 1) {
        document.cookie = `token=${res.data.token}; path=/;`;
      }
    }
  },
  async mounted() {
    //获取文档类型
    this.getToken()
    this.webTypeList = await getBaseDictList(703, 1, 100);
    this.teacherTypeList = await getBaseDictList(701, 1, 100);
    this.parentTypeList = await getBaseDictList(702, 1, 100);
    this.allTypeList = [...this.webTypeList, ...this.teacherTypeList, ...this.parentTypeList];
    this.tableData = await this.getDataList();
  },
};
</script>
<style lang="scss" scoped>
.dt-usermange-container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 30px;
}

.dt-search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dt-search-icon {
  margin-top: 50%;
  transform: translateY(-20%);
  margin-right: 20px;

}

.dt-opera-cell {
  display: flex;
  padding: 0 30px;
  justify-content: space-around;
  align-items: center;
  color: #3e73f6;
  cursor: pointer;
}
</style>
<style lang="scss">
.dt-usermange-container {
  .el-dialog__header {
    text-align: unset !important;
    border-bottom: 1px solid #f0f0f0;
    background-color: #fafafa;

    .el-dialog__title {
      padding-top: 0;
    }
  }

  .el-pagination {
    text-align: center;
    margin-top: 20px;
  }
}
</style>